import styles from './MenuSeparator.module.css';

/**
 * Menu.Separator
 *
 * A thin horizontal rule for grouping related items visually. Drop it between
 * any two rows inside `Menu.Content` or `Submenu.Content`.
 */

export function MenuSeparator() {
  return <div className={styles.separator} role="separator" />;
}

export function MenuSpacer() {
  return <div className={styles.spacer} role="separator" />;
}
